"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Commander Spellbook API
 * API for Commander Spellbook, the combo database engine for Magic: The Gathering
 *
 * The version of the OpenAPI document: 4.8.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedVariantAliasList = instanceOfPaginatedVariantAliasList;
exports.PaginatedVariantAliasListFromJSON = PaginatedVariantAliasListFromJSON;
exports.PaginatedVariantAliasListFromJSONTyped = PaginatedVariantAliasListFromJSONTyped;
exports.PaginatedVariantAliasListToJSON = PaginatedVariantAliasListToJSON;
exports.PaginatedVariantAliasListToJSONTyped = PaginatedVariantAliasListToJSONTyped;
const variantAlias_1 = require("./variantAlias");
/**
 * Check if a given object implements the PaginatedVariantAliasList interface.
 */
function instanceOfPaginatedVariantAliasList(value) {
    if (!('count' in value) || value['count'] === undefined)
        return false;
    if (!('next' in value) || value['next'] === undefined)
        return false;
    if (!('previous' in value) || value['previous'] === undefined)
        return false;
    if (!('results' in value) || value['results'] === undefined)
        return false;
    return true;
}
function PaginatedVariantAliasListFromJSON(json) {
    return PaginatedVariantAliasListFromJSONTyped(json, false);
}
function PaginatedVariantAliasListFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'count': json['count'],
        'next': json['next'],
        'previous': json['previous'],
        'results': (json['results'].map(variantAlias_1.VariantAliasFromJSON)),
    };
}
function PaginatedVariantAliasListToJSON(json) {
    return PaginatedVariantAliasListToJSONTyped(json, false);
}
function PaginatedVariantAliasListToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': (value['results'].map(variantAlias_1.VariantAliasToJSON)),
    };
}
//# sourceMappingURL=paginatedVariantAliasList.js.map